import React , { useState, useEffect } from 'react';
import './style.css';
import HomeLeft from './home_left/index';
import HomeRight from './home_right/index';
import Footer from '../shared/footer/index';
import {Container,Row,Col} from 'react-bootstrap';
import Animate from 'react-smooth';
import ReactGA from 'react-ga';
import Loader from '../shared/loader/Loader'
import Google_Analytics from '../../const/Google_Anlytics'



function Home() {

  const [loading, setLoading] = useState(true);


  const setLoader =()=> {

   setTimeout(() => setLoading(false), 2000);

  }


  const Analytics=()=>{
  
    ReactGA.initialize(Google_Analytics.Tracking_Id);
    ReactGA.pageview('Wejdi Gharbi- Home Screen');
    
  }
  

  useEffect(() => {
    Analytics()
    let timer = setLoader()
    return ()=> clearTimeout(timer)
  },[]);


  
  return (
    loading ? <Loader/> :
      <div>
          <Animate to="1" from="0" attributeName="opacity">

          <Container className="App-header" fluid={true}>
            <Row className="App-main">
              <Col  xl={6}  className="App-left">
                <HomeLeft />
              </Col>
              <Col  xl={6} className="App-right">
                <HomeRight />
              </Col>
            </Row>
            <Row className="App-footer">
              <Footer />
            </Row>
        </Container>
        </Animate>
      </div>
    );
}

export default Home;
